import axios from 'axios';
import qs from 'qs';
import urls from '@/settings/urls';

export const GetOperatorsList = (params) => {
  //params = fillDefaultParams(params);
  const requestOptions = {
    method: 'GET',
    url: urls.admin.clients,
    params,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data)
    .catch(e => console.log('mail list get err', e)); // TEMP: to do: if 419 update token and make new req
}

export const AlterCustomerStatus = (params) => {
  //params = fillDefaultParams(params);
  const requestOptions = {
    method: 'PUT',
    url: urls.admin.set_is_active,
    data: params,
  };

  return axios(requestOptions)
    .then(res => res.data)
    .catch(e => { console.log('mail list get err', e); throw e;}); // TEMP: to do: if 419 update token and make new req
}

export const GetOperatorsListCSV = (params) => {
  //params = fillDefaultParams(params);
  const requestOptions = {
    method: 'GET',
    url: urls.admin.clients+'.csv',
    params,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data)
    .catch(e => console.log('mail list get err', e)); // TEMP: to do: if 419 update token and make new req
}